import { z } from 'zod'

import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

const MissedPaymentSchema = z.object({
  amount: z.number(),
  currency: z.number()
})

const MissedClientsSchema = z.object({
  client_count: z.number(),
  clients: z.array(
    z.object({
      company_name: z.string(),
      company_website: z.string().nullable()
    })
  )
})

const MissedOpportunitiesSchema = z.object({
  status: z.literal('success'),
  count: z.number(),
  missed_payment: MissedPaymentSchema,
  missed_clients: MissedClientsSchema
})

export type MissedOpportunities = z.infer<typeof MissedOpportunitiesSchema>

const getMissedOpportunitiesStats = async (): Promise<
  ApiResponseV2<MissedOpportunities>
> => {
  try {
    const endpoint = '/opportunities/missed-stats'
    const response = await axios.get<MissedOpportunities>(endpoint)

    MissedOpportunitiesSchema.parse(response.data)

    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}

export default getMissedOpportunitiesStats
